module.exports = __webpack_public_path__ + "static/media/Icona-12.d332aeaf.svg";